import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NotInput } from '@nebalkon-workspace/ui-kit';
import { CabinetButtonComponent } from '@nebalkon-workspace/cabinet-client';
import { OrderStatuses } from '@nebalkon-workspace/order-api';
import { StaffOrderDetailFacade } from './staff-order-detail.facade';

@Component({
  selector: 'lib-staff-order-detail-manager-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, FormsModule, CabinetButtonComponent, NotInput],
  templateUrl: './staff-order-detail-manager-panel.component.html',
  styleUrl: './staff-order-detail-panels.component.scss',
})
export class StaffOrderDetailManagerPanelComponent {
  readonly facade = inject(StaffOrderDetailFacade);
  readonly OrderStatuses = OrderStatuses;
}
